import { HttpParams } from '@angular/common/http';
import { Injectable, Injector } from '@angular/core';
import { LazyLoadEvent } from 'primeng/primeng';

import { BaseCrudService } from '../../shared/_utils/services/base-crud-service';
import { QueryOperator } from '../../shared/_utils/services/query-operator.enum';
import { ProgrammaticStructure } from '../entities/programmaticStructure';

@Injectable()
export class ProgrammaticStructureService extends BaseCrudService<ProgrammaticStructure> {

    public uri = '/api/programmaticStructure/';

    constructor(injector: Injector) {
        super(injector);
       //console.log('Instance ProgrammaticStructureService');
    }

    buildSentence(entity?: ProgrammaticStructure, event?: LazyLoadEvent): HttpParams {
        if (entity) {
            let query = entity.code ? 'code'
                + QueryOperator.Contain + entity.code
                + QueryOperator.Split : QueryOperator.Empty;
            query = query.concat(
                entity.name ? 'name'
                + QueryOperator.Contain + entity.name
                + QueryOperator.Split : QueryOperator.Empty
            );
            query = query.concat(
                entity.longname ? 'longname'
                + QueryOperator.Contain + entity.longname
                + QueryOperator.Split : QueryOperator.Empty
            );
            query = query.concat(
                entity.goalCode ? 'goalCode'
                + QueryOperator.Contain + entity.goalCode
                + QueryOperator.Split : QueryOperator.Empty
            );
            query = query.concat(
                entity.sequential ? 'sequential'
                + QueryOperator.Contain + entity.sequential
                + QueryOperator.Split : QueryOperator.Empty
            );
            query = query.concat(
                entity.status ? 'status'
                + QueryOperator.Equal + entity.status
                + QueryOperator.Split : QueryOperator.Empty
            );

            if (entity.executingUnit) {
                query = query.concat(
                    entity.executingUnit.id ? 'executingUnit.id'
                    + QueryOperator.Equal + entity.executingUnit.id
                    + QueryOperator.Split : QueryOperator.Empty
                );
            }

            if (entity.levelProgStructure) {
                query = query.concat(
                    entity.executingUnit.id ? 'levelProgStructure.id'
                    + QueryOperator.Equal + entity.levelProgStructure.id
                    + QueryOperator.Split : QueryOperator.Empty
                );
            }

            if (entity.fiscalYear) {
                query = query.concat(
                    entity.fiscalYear.id ? 'fiscalYear.id'
                    + QueryOperator.Equal + entity.fiscalYear.id
                    + QueryOperator.Split : QueryOperator.Empty
                );
            }

            this.httpParams = this.httpParams.set(QueryOperator.QueryParam, query);
        }

        if (event) {
            const page = ((event.first + event.rows) / event.rows - 1 ).toString();
            const size = event.rows.toString();
            this.httpParams = this.httpParams.set(QueryOperator.PageParam, page);
            this.httpParams =  this.httpParams.set(QueryOperator.SizeParam, size);
        }
        this.httpParams =  this.httpParams.set(QueryOperator.SortParam, 'code');
        return this.httpParams;
    }
}



// WEBPACK FOOTER //
// ./src/app/core/services/programmatic-structure.service.ts